import type { ResourcesCardProps } from "../_model";
import { splitProps } from "solid-js";
import { global } from ":shared/app";
export function ResourcesCard(props: ResourcesCardProps) {
  const [local, others] = splitProps(props, ["link", "image", "title", "category", "description", "id"]);
  const badge = global.store.actions.flavors.getBadgeStyle({ track: local.category });
  return (
    <a
      {...others}
      href={local.link}
      target="_blank"
      class={
        "no-underline w-full min-h-350px h-350px max-h-350px flex flex-col relative rounded-xl bg-bg !overflow-hidden border-1 border-bg-alt border-solid" +
        " " +
        (others.class == undefined ? "" : others.class)
      }
    >
      <div class="flex w-full min-h-50% h-50%">
        <img class="w-full h-full object-stretch" src={local.image ?? "/images/placeholders/cover.png"} alt="alt" />
      </div>
      <div class="flex flex-col px-2 py-1 w-full h-auto">
        <span
          style={badge.style}
          class="w-fit h-auto bg-badge-bg text-badge-text text-14px py1 px2 rounded-xl whitespace-nowrap"
        >
          {local.category ?? "No category"}
        </span>
      </div>
      <p class="flex h-180px font-bold py-1 px2 whitespace-nowrap  text-truncate">{local.title ?? "No Title"}</p>
      <p class="flex w-full h-full text-16px  pt-1 mb-1.5 px2 !overflow-y-auto overflow-x-hidden scrollbar">
        {local.description ?? "No description"}
      </p>
    </a>
  );
}
